<template>
  <div class="card mb-5 bg-light border-0">
    <div class="card-body py-5 text-center">
      <svg v-if="errorType === 'select_service_type'" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-arrow-left-circle opacity-5 mb-1" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
      </svg>
      <svg v-else xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-exclamation-triangle-fill opacity-5 mb-1" viewBox="0 0 16 16">
        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
      </svg>
      <div v-if="errorType === 'connection_error'">
        <p class="text-muted fw-bold mb-1">We're having trouble accessing appointment availability right now.</p>
        <p class="text-muted mb-0">Please try again shortly, or call us directly to book your appointment.</p>
      </div>
      <div v-else-if="errorType === 'service_unavailable'">
        <p class="text-muted mb-0">{{ message || "Appointment booking is temporarily unavailable" }}</p>
      </div>
      <p v-else class="text-muted mb-0">
        {{ message }}
      </p>
    </div>
  </div>
</template>

<script charset="utf-8">
export default {
  name: "Error",
  props: ["message", "errorType"],
};
</script>
